import {default as Component} from './UserLoginControl'
import {showModalPopup} from '../../redux/actions'
import {connect} from 'react-redux'
import {MODAL_POPUP_ID} from '../../redux/const'

const UserLoginControl = connect(
	(state) => ({
		visible: !state.login.isLoggedIn,
	}),
	(dispatch) => ({
		click: () => {
			dispatch(showModalPopup(MODAL_POPUP_ID.LOGIN))
		},
	})
)(Component)

UserLoginControl.defaultProps = {
	visible: null,
	click: null,
}

export default UserLoginControl


// WEBPACK FOOTER //
// ./src/components/UserLoginControl/index.js